import request from '@/service/api'
import ConfigType from '@/service/api/type'
//系统管理API
enum SystemApi {
    // 部门管理
    ORG_LIST = '/sysOrg/page', //查询
    ORG_DELETE = '/sysOrg/delete', //删除
    ORG_ADD = '/sysOrg/add', //新增
    ORG_EDIT = '/sysOrg/edit', //编辑
    // 职位管理
    POSITION_LIST = '/sysPos/page',//查询
    POSITION_ADD = "/sysPos/add",//新增
    POSITION_EDIT = "sysPos/edit",//编辑
    POSITION_DELETE = "/sysPos/delete",//删除
    // 用户管理
    USER_LIST = '/sysUser/page', //用户列表
    USER_DEL = '/sysUser/delete', //删除用户
    USER_RESET = "/sysUser/resetPwd",
    USER_ADD = '/sysUser/add', //添加用户
    USER_EDIT = '/sysUser/edit', //编辑用户
    ROLE_LIST = '/sysRole/page', //角色列表
    USER_ROLES = "/sysUser/grantRole",
    GET_USER_ROLES = "/sysUser/ownRole",
    USER_SYSROLE = '/sysRole/dropDown',//用户角色下拉框
    // 角色管理
    ROLE_DEL = '/sysRole/delete', //删除角色
    ROLE_ADD = '/sysRole/add', //添加角色
    ROLE_EDIT = '/sysRole/edit', //编辑角色
    GET_MENU_TREE = "/sysMenu/list", //获取树形菜单列表
    GET_PDAMENU_TREE = "/sysMenu/listpda", //获取树形菜单列表
    GET_ROLE_OWNMENU = '/sysRole/ownMenu', //获取角色下的菜单权限
    GET_ROLE_OWNPDAMENU='/sysRole/ownPdaMenu',//获取角色下的pda菜单权限
    SET_ROLE_MENU = "/sysRole/grantMenu", //分配角色菜单权限
    SET_ROLE_PDAMENU = "/sysRole/grantPdaMenu", //PDA授权
    // 文件管理
    FILELIST = 'sysFileInfo/page',//文件管理列表
    FILEDOWNLOAD = '/sysFileInfo/download',//文件下载
    FILEDELETE = '/sysFileInfo/delete',//文件删除
    // 字典管理
    DICT_LIST = '/sysDictType/page',//字典类型列表
    DICT_ADD = '/sysDictType/add',//新增字典
    DICT_EDIT = '/sysDictType/edit',//编辑字典
    DICT_DELETE = '/sysDictType/delete',//删除字典
    DICT_STATUS = '/sysDictType/changeStatus',//修改字典状态
    DICT_CHILDLIST = '/sysDictData/page',//字典值列表
    DICT_ADDCHILD = '/sysDictData/add',//新增字典值
    DICT_EDITCHILD = '/sysDictData/edit',//编辑字典值
    DICT_DELETECHILD = '/sysDictData/delete',//删除字典值
    DICT_STATUSCHILD = '/sysDictData/changeStatus',//修改字典值状态
    //系统配置
    SETTING_LIST = '/sysConfig/page',//系统配置列表
    SETTING_ADD = '/sysConfig/add',//新增系统配置
    SETTING_EDIT = '/sysConfig/edit',//编辑系统配置
    SETTING_DELETE = '/sysConfig/delete',//删除系统配置
}
/******************************************************************************************部门管理******************************************************************************************/
//查询
export const getOrgList = (data: any): ConfigType<any> => {
    return request({
        url: `${SystemApi.ORG_LIST}`,
        params: data
    })
}
//删除
export const delOrg = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.ORG_DELETE,
        method: "post",
        data: data
    })
}

//新增
export const addOrg = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.ORG_ADD,
        method: "post",
        data: data
    })
}

//编辑
export const editOrg = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.ORG_EDIT,
        method: "post",
        data: data
    })
}
/******************************************************************************************职位管理******************************************************************************************/
//获取职位管理分页列表
export const getPositionList = (data: any): ConfigType<any> => {
    return request({
        url: `${SystemApi.POSITION_LIST}`,
        params: data
    })
}
// 职位新增
export const addPositionList = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.POSITION_ADD,
        method: "post",
        data: data
    })
}
// 职位编辑
export const editPositionList = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.POSITION_EDIT,
        method: "post",
        data: data
    })
}
// 职位删除
export const deletePositionList = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.POSITION_DELETE,
        method: "post",
        data: data
    })
}
/******************************************************************************************用户管理******************************************************************************************/
//获取用户列表
export const getUsersList = (data: any): ConfigType<any> => {
    return request({
        url: `${SystemApi.USER_LIST}`,
        params: data
    });
}
//删除用户
export const delUser = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.USER_DEL,
        method: 'post',
        data: data
    })
}
//重置密码
export const reset = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.USER_RESET,
        method: 'post',
        data: data
    });
}
//添加用户
export const addUser = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.USER_ADD,
        method: 'post',
        data: data
    })
}
//编辑用户
export const editUser = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.USER_EDIT,
        method: 'post',
        data: data
    })
}
//获取角色列表
export const getRolesList = (data: any): ConfigType<any> => {
    return request({
        url: `${SystemApi.ROLE_LIST}`,
        params: data
    })
}
//分配角色
export const grantRole = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.USER_ROLES,
        method: 'post',
        data: data
    });
}
//获取指定用户的角色权限
export const getUserRoleList = (id: number) => {
    return request({
        url: `${SystemApi.GET_USER_ROLES}?Id=${id}`
    });
}
// 获取用户角色下拉框数据
export const roleSelect = () => {
    return request({
        url: `${SystemApi.USER_SYSROLE}`
    })
}
/******************************************************************************************角色管理******************************************************************************************/
//删除角色
export const delRole = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.ROLE_DEL,
        method: 'post',
        data: data
    })
}
//添加角色
export const addRole = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.ROLE_ADD,
        method: 'post',
        data: data
    })
}

//编辑角色
export const editRole = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.ROLE_EDIT,
        method: 'post',
        data: data
    })
}
//获取菜单列表树形
export const getMenuTree = () => {
    return request({
        url: `${SystemApi.GET_MENU_TREE}`
    });
}

//获取pda菜单列表树形
export const getPdaMenuTree = () => {
    return request({
        url: `${SystemApi.GET_PDAMENU_TREE}`
    });
}

//获取指定用户的角色权限
export const getRoleOwnMenu = (id: number) => {
    return request({
        url: `${SystemApi.GET_ROLE_OWNMENU}?Id=${id}`
    });
}


//获取指定用户的角色的pda菜单权限
export const getRoleOwnPdaMenu = (id: number) => {
    return request({
        url: `${SystemApi.GET_ROLE_OWNPDAMENU}?Id=${id}`
    });
}

//分配角色菜单全选
export const setRoleMenuPage = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.SET_ROLE_MENU,
        method: 'post',
        data: data
    });
}

//pda授权
export const setRolePdaMenu = (data: any): ConfigType<any> => {
    return request({
        url: SystemApi.SET_ROLE_PDAMENU,
        method: 'post',
        data: data
    });
}
/******************************************************************************************文件管理******************************************************************************************/
//文件管理列表
export const getFilesList = (data: any): ConfigType<any> => {
    return request({
        url: `${SystemApi.FILELIST}`,
        params: data
    })
}
//文件下载
export const getDownLoad = (data: any = {}) => {
    return request({
        url: `${SystemApi.FILEDOWNLOAD}`,
        params: data,
        responseType: 'blob'
    })
}
// 文件删除
export const deleteFilesList = (data: any = {}) => {
    return request({
        url: SystemApi.FILEDELETE,
        method: 'post',
        data
    })
}
/******************************************************************************************字典管理******************************************************************************************/
//字典类型列表
export const getDictList = (data: any = {}) => {
    return request({
        url: `${SystemApi.DICT_LIST}`,
        params: data
    })
}
//字典新增
export const addDictList = (data: any = {}) => {
    return request({
        url: SystemApi.DICT_ADD,
        method: 'post',
        data: data
    })
}
//字典编辑
export const editDictList = (data: any = {}) => {
    return request({
        url: SystemApi.DICT_EDIT,
        method: 'post',
        data: data
    })
}
// 字典删除
export const deleteDictList = (data: any = {}) => {
    return request({
        url: SystemApi.DICT_DELETE,
        method: 'post',
        data: data
    })
}
//字典状态修改
export const alertDictStatus = (data: any = {}) => {
    return request({
        url: SystemApi.DICT_STATUS,
        method: 'post',
        data: data
    })
}
//字典值列表
export const getDictValueList = (data: any = {}) => {
    return request({
        url: `${SystemApi.DICT_CHILDLIST}`,
        params: data
    })
}
// 字典值新增
export const addDictValueList = (data: any = {}) => {
    return request({
        url: SystemApi.DICT_ADDCHILD,
        method: 'post',
        data: data
    })
}
// 字典值编辑
export const editDictValueList = (data: any = {}) => {
    return request({
        url: SystemApi.DICT_EDITCHILD,
        method: 'post',
        data: data
    })
}
// 字典值删除
export const deleteDictValueList = (data: any = {}) => {
    return request({
        url: SystemApi.DICT_DELETECHILD,
        method: 'post',
        data: data
    })
}
//字典值状态修改
export const alertDictValueStatus = (data: any = {}) => {
    return request({
        url: SystemApi.DICT_STATUSCHILD,
        method: 'post',
        data: data
    })
}
/******************************************************************************************系统配置******************************************************************************************/
// 系统配置列表
export const getSettingList = (data: any = {}) => {
    return request({
        url: `${SystemApi.SETTING_LIST}`,
        params: data
    })
}
// 系统配置新增
export const addSettingList = (data: any = {}) => {
    return request({
        url: SystemApi.SETTING_ADD,
        method: 'post',
        data: data
    })
}
// 系统配置编辑
export const editSettingList = (data: any = {}) => {
    return request({
        url: SystemApi.SETTING_EDIT,
        method: 'post',
        data: data
    })
}
// 系统配置删除
export const deleteSettingList = (data: any = {}) => {
    return request({
        url: SystemApi.SETTING_DELETE,
        method: 'post',
        data: data
    })
}